import * as React from "react";
const SvgAttachFolder = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M2.5 6.83073C2.5 5.89731 2.5 5.4306 2.68166 5.07408C2.84144 4.76047 3.09641 4.50551 3.41002 4.34572C3.76654 4.16406 4.23325 4.16406 5.16667 4.16406H8.0621C8.46975 4.16406 8.67357 4.16406 8.86539 4.21011C9.03545 4.25094 9.19802 4.31828 9.34714 4.40966C9.51534 4.51273 9.65946 4.65686 9.94772 4.94511L10.0523 5.04968C10.3405 5.33793 10.4847 5.48206 10.6529 5.58513C10.802 5.67651 10.9646 5.74385 11.1346 5.78468C11.3264 5.83073 11.5303 5.83073 11.9379 5.83073H14.8333C15.7668 5.83073 16.2335 5.83073 16.59 6.01239C16.9036 6.17217 17.1586 6.42714 17.3183 6.74075C17.5 7.09726 17.5 7.56398 17.5 8.4974V13.1641C17.5 14.0975 17.5 14.5642 17.3183 14.9207C17.1586 15.2343 16.9036 15.4893 16.59 15.6491C16.2335 15.8307 15.7668 15.8307 14.8333 15.8307H5.16667C4.23325 15.8307 3.76654 15.8307 3.41002 15.6491C3.09641 15.4893 2.84144 15.2343 2.68166 14.9207C2.5 14.5642 2.5 14.0975 2.5 13.1641V6.83073Z",
      stroke: "currentColor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
export default SvgAttachFolder;
